
export class Generator {
    static instance = new Generator()

    async generateSvg(gv: string) : Promise<string> {
        let response = await fetch('https://dot.stepanrutz.com/services/dot?code=3363c2ea-d419-11ea-bbd9-3bb53b909944', {
            method: 'post',
            body: gv
        })
        let blob = await response.blob()
        let svg = await blob.text()
        if (svg) {
            let i0 = svg.indexOf("<?xml")
            if (i0 > 0)
                svg = svg.substring(i0)
        }
        if (!true) {
            let save = (filename: string, data: string): void => {
                let blob = new Blob([data], {type: 'text/csv'});
                let elem = window.document.createElement('a');
                elem.href = window.URL.createObjectURL(blob);
                elem.download = filename;        
                document.body.appendChild(elem);
                elem.click();        
                document.body.removeChild(elem);
            }
            save("dump.svg", svg)
        }
        return svg;
    }
}